import { Box } from '@jfs/ui-new'
import { DropdownOptimised } from '../DropdownNew'
import { DropdownTypes } from '../DropdownNew/types'

const searchFiltersData = [
  // { id: '1', value: 'Single Beneficiary' },
  { id: '2', value: 'Bulk Beneficiary' },
]

const AddBeneficiary = ({ selectedItem, valueSelected }: any) => {
  const handleKeyChange = (value: string) => {
    selectedItem && selectedItem(value)
  }
  return (
    <Box bg={'WHITE'}>
      <Box flexDirection="row">
        <DropdownOptimised
          placeHolder={'+ Add Beneficiary'}
          type={DropdownTypes.ADD_BENEFICIARY}
          data={searchFiltersData}
          value={valueSelected}
          labelColor={'BLUE'}
          titleColor={'WHITE'}
          onChange={handleKeyChange}
          chevronColor={'WHITE'}
        />
      </Box>
    </Box>
  )
}

export { AddBeneficiary }
